import { render, staticRenderFns } from "./BasicImage.vue?vue&type=template&id=7b633e94"
import script from "./BasicImage.vue?vue&type=script&lang=ts"
export * from "./BasicImage.vue?vue&type=script&lang=ts"
import style0 from "./BasicImage.vue?vue&type=style&index=0&id=7b633e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports